import {
  Dialog,
  DialogTitle,
  DialogActions,
} from "V2.0/common/dialog";
import { Button } from "V2.0/common/button";
import { useState } from "react";
import { message } from "antd";
import { showErrorToast } from "V2.0/utils";

function NoteDelete(props) {
  const { open, onClose, onDelete } = props;

  const [loading, setLoading] = useState(false);

  const handleDelete = () => {
    const lifecycleCbs = {
      onInit: () => {
        setLoading(true);
        message.loading("Deleting Note");
      },
      onSuccess: () => {
        setLoading(false);
        message.destroy();
        message.success("Note deleted");
        onClose();
      },
      onError: (e) => {
        setLoading(false);
        message.destroy();
        showErrorToast(e, "Failed to delete note");
      },
    };
    onDelete(lifecycleCbs);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Delete Note?</DialogTitle>
      <DialogActions>
        <Button outline onClick={onClose}>
          Cancel
        </Button>
        <Button loading={loading} onClick={handleDelete}>Delete</Button>
      </DialogActions>
    </Dialog>
  );
}

export default NoteDelete;
